export default "__VITE_ASSET__841a42ff__"